import React from 'react';
import PropTypes from 'prop-types';
import { costFormatter } from '@format/currency';
import {
  DescriptionList,
  DescriptionListLabel,
  DescriptionListValue,
} from '@web/atoms';
import { addonsQuantityFormatter } from '../../addons';
import { forEachAddon } from './constants';
import {
  StyledAddonsSummary,
  SummaryInfo,
  HeadlineContainer,
  Headline,
  StrikePrice,
  DiscountedPrice,
  QuantityLabel,
} from './styles.js';

export const AddonsSummary = ({ petId, addons }) => {
  return (
    <StyledAddonsSummary>
      <HeadlineContainer>
        <Headline>Subscription Extras</Headline>
      </HeadlineContainer>
      <SummaryInfo>
        {addons &&
          addons.map(
            ({
              sku,
              productName,
              quantity,
              productType,
              price,
              discountedPrice,
            }) => {
              return (
                <DescriptionList key={productName}>
                  <DescriptionListLabel>
                    {productName} -{' '}
                    <QuantityLabel>
                      {addonsQuantityFormatter(quantity, productType, sku)}
                    </QuantityLabel>
                  </DescriptionListLabel>
                  <DescriptionListValue>
                    <StrikePrice>{costFormatter(price)}</StrikePrice>
                    <DiscountedPrice>
                      {costFormatter(discountedPrice)}/{forEachAddon}
                    </DiscountedPrice>
                  </DescriptionListValue>
                </DescriptionList>
              );
            },
          )}
      </SummaryInfo>
    </StyledAddonsSummary>
  );
};

AddonsSummary.displayName = 'AddonsSummary';
AddonsSummary.propTypes = {
  petId: PropTypes.string,
  addons: PropTypes.array,
};
